import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import styled from 'styled-components';
import Layout from 'components/Layout';
import ComponentRenderer from './ComponentRenderer';

const StyledLayoutSection = styled(Layout.Section)`
    grid-template-columns: repeat(1, minmax(0, 1fr));

    &:empty {
        // to remove grid gap, if section has no children.
        display: none;
    }
`;

function TemplateComponentRenderer(content) {
    if (content.sys?.contentType?.sys?.id !== 'layout') {
        return (
            <StyledLayoutSection key={content.sys.id} contentRenderer={(children) => <>{children}</>}>
                <ComponentRenderer {...content} />
            </StyledLayoutSection>
        );
    }
    return (
        <React.Fragment key={content.sys.id}>
            <ComponentRenderer {...content} />
        </React.Fragment>
    );
}

export default withErrorBoundary(TemplateComponentRenderer, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
